
import {Vue, Component} from 'vue-property-decorator';
import {GOOGLE_MAPS_KEY, nil} from '@/common';
import {multiNil} from '../common';
import {FeathersVuexFindAll} from '../utils';
@Component({
    components: {
    },
})
export default class BookingMetadataMixin extends Vue {
    public async getPurchasable(booking) {
        if (nil(booking)) { return null; }
        if (!multiNil(booking, 'purchasableModel')) { return booking.purchasableModel; }
        const {Purchasable} = this.$FeathersVuex;
        const results = await Purchasable.find({query: {_id: booking.purchasable}});
        if (results.total === 0) { return null; }
        return results.data[0];
    }
    public async getCategory(booking) {
        if (nil(booking)) { return null; }
        if (!multiNil(booking, 'purchasableModel.categoryModel')) { return booking.purchasableModel.categoryModel; }
        const {Category} = this.$FeathersVuex;
        const results = await Category.find({query: {_id: booking.purchasableModel.category}});
        if (results.total === 0) { return null; }
        return results.data[0];
    }
    public async getTier(booking) {
        if (nil(booking)) { return null; }
        if (!multiNil(booking, 'purchasableModel.tierModel')) { return booking.purchasableModel.tierModel; }
        const {Tier} = this.$FeathersVuex;
        const results = await Tier.find({query: {_id: booking.purchasableModel.tier}});
        if (results.total === 0) { return null; }
        return results.data[0];
    }
    public async getClaims(booking, disablePagination = false) {
        if (nil(booking)) { return []; }
        const {VendorClaim} = this.$FeathersVuex;
        const claims = await FeathersVuexFindAll(VendorClaim, {
            query: {
                booking: booking._id,
            },
        }, disablePagination);
        return claims;
    }
    public async getClaim(booking, vendorId) {
        if (nil(booking) || nil(vendorId)) { return null; }
        const {VendorClaim} = this.$FeathersVuex;
        const results = await VendorClaim.find({
            query: {
                booking: booking._id,
                vendor: vendorId,
            },
        });
        if (results.total === 0) { return null; }
        return results.data[0];
    }
    public async getOrder(booking){
        if(nil(booking)){ return null; }
        const {Order} = this.$FeathersVuex;
        const o = await Order.find({query:{
            bookings:[booking._id],
        }});
        if(o.data.length !== 1){
            return null;
        }
        return o.data[0];
    }
    public async getCardHolderName(booking){
        if(!nil(booking.cardholder)) return booking.cardholder;
        const o = await this.getOrder(booking);
        if(nil(o)){
            return null;
        }
        const {charges} = o.stripePaymentObject;
        if(nil(charges) || nil(charges.data, true) || nil(charges.data[0].billing_details)){
            return null;
        }
        return charges.data[0].billing_details.name;
    }
}
